<template>
<div class="chapter">
<div class="inner_page">
<div> <a id="htp"></a></div>
<p class="center" style="margin-top: 15%; font-size: 150%">J<span class="sc">ESSIE</span>’<span class="sc">S</span> J<span class="sc">OURNEY</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 001_htp.vue?4e0fdf3e